import { render, staticRenderFns } from "./TreeView.vue?vue&type=template&id=04bd79d4"
import script from "./TreeView.ts?vue&type=script&lang=ts&external"
export * from "./TreeView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports